<template>
  <div class="chapter">
    <div class="inner_page">
      <template>
<p>
We hope you enjoyed reading this book sample.<br/>
Please click on any of the store links to buy it or the social links to recommend it.<br/>
Thank you.
</p>
</template>
<script>
export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>
  </div>
  </div>
</template>

<script>

export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>




// WEBPACK FOOTER //
// last.vue?2df21a18